﻿; (function ($) {

    "use strict";

    var kendo = window.kendo;
    if (!kendo || !kendo.ui || kendo.ui.errorHighlightingUpdated) {
        return;
    }

    var // common consts etc.
        CLASS_INVALID_MSG = "k-invalid-msg",
        REGEX_INVALID_MSG = new RegExp(CLASS_INVALID_MSG, "i"),
        ARIA_INVALID = "aria-invalid",
        ARIA_DESCRIBED_BY = "aria-describedby",
        HIDDEN = "hidden",
        HIDDEN_VISUALLY = "hidden-visually",
        CHECKBOX = "[type=checkbox]",
        HIDDEN_INPUT = "input[type=hidden]",
        FORM = "form",
        UL = "ul",
        VISIBLE_LIST_ITEM = "li:visible",
        LABEL = "label",
        CONTROL_WRAPPER = ".w-control",
        SPAN = "<span />",
        ATTR_ID = "id",
        ATTR_NAME = "name",
        ATTR_TITLE = "title",
        ATTR_FOR = "for",
        ATTR_ROLE = "role",
        ALERT = "alert",
        // description UI type data
        ATTR_DESCR_UI_TYPE = "descrUi",
        // description UI types
        DESCR_UI_TITLE = "title",
        DESCR_UI_TOOLTIP = "tooltip",
        // default description icon CSS class
        DESCR_ICON = "title-icon",
        // validation UI type data
        ATTR_VAL_UI_TYPE = "valUi",
        // validation UI types
        VAL_UI_NONE = "none",
        VAL_UI_HIGHLIGHT = "highlight",
        VAL_UI_TITLE = "title",
        VAL_UI_TOOLTIP = "tooltip",
        VAL_UI_ICON = "icon",
        VAL_UI_BEFORE = "before",
        VAL_UI_AFTER = "after",
        VAL_UI_ELEMENT = "element",
        // icon classes on widgets
        ERROR = "error",
        SUCCESS = "success",
        ERROR_ICON = "error-icon",
        SUCCESS_ICON = "success-icon",
        WITH_VAL_ICON = "with-validation-icon",
        DEFAULT_DURATION = 200,
        // error templates
        WIDGET_ERROR_TEMPLATE_PREFIX = "widget_error_",
        SUMMARY_ERROR_TEMPLATE_PREFIX = "summary_error_",
        DEFAULT_ERROR_TEMPLATE = "<label#=control#>#=message#</label>",
        DEFAULT_SUMMARY_ERROR_TEMPLATE = "<li><label#=control#>#=message#</label></li>",
        DEFAULT_OPTIONS = {
            // default validation UI type; used when this kind of data
            // is not present in widget instance it or in its markup
            validationUi: VAL_UI_ICON,
            // validator message templates are now split into several sections
            // according to validation UI type; for each validation UI type
            // both templates for widget message and summary message may be needed
            templates: {
                // widgets
                widget_error_none: "",
                widget_error_highlight: "",
                widget_error_title: "#=message#",
                widget_error_tooltip: "<span>#=message#</span>",
                widget_error_icon: '<span class="k-icon #=errorIconClass#" data-tooltip-offset="15"></span>',
                widget_error_before: DEFAULT_ERROR_TEMPLATE,
                widget_error_after: DEFAULT_ERROR_TEMPLATE,
                widget_error_element: DEFAULT_ERROR_TEMPLATE,
                // summary
                summary_error_none: DEFAULT_SUMMARY_ERROR_TEMPLATE,
                summary_error_highlight: DEFAULT_SUMMARY_ERROR_TEMPLATE,
                summary_error_title: DEFAULT_SUMMARY_ERROR_TEMPLATE,
                summary_error_tooltip: DEFAULT_SUMMARY_ERROR_TEMPLATE,
                summary_error_icon: DEFAULT_SUMMARY_ERROR_TEMPLATE,
                summary_error_before: DEFAULT_SUMMARY_ERROR_TEMPLATE,
                summary_error_after: DEFAULT_SUMMARY_ERROR_TEMPLATE,
                summary_error_element: DEFAULT_SUMMARY_ERROR_TEMPLATE
            },
            // animations duration
            duration: DEFAULT_DURATION,
            // options to redefine validation summary section classes
            successIconCssClass: SUCCESS_ICON,
            errorIconCssClass: ERROR_ICON,
            // options to redefine validation summary section classes
            successSummaryCssClass: SUCCESS,
            errorSummaryCssClass: ERROR
        };

    /**
     * Hides the specified element, optionally executing a callback function
     * after the animation end.
     */
    function hideElement(element, callback, duration) {
        var $element = $(element);
        if (!$element.length) {
            return;
        }
        duration = duration || DEFAULT_DURATION;
        $element
            .stop(true, false)
            .fadeOut({
                duration: duration,
                complete: function () {
                    $element
                        .addClass(HIDDEN)
                        .removeAttr("style");
                    if (typeof callback == "function") {
                        callback();
                    }
                }
            });
    }

    function searchForMessageContainer($elements, fieldName) {
        var containers = $();
        for (var i = 0, length = $elements.length; i < length; i++) {
            var element = $elements[i];
            if (!REGEX_INVALID_MSG.test(element.className)) {
                continue;
            }
            var attr = element.getAttribute(kendo.attr(ATTR_FOR));
            if (attr === fieldName) {
                containers = containers.add(element);
            }
        }
        return containers;
    }

    function findMessageContainer(context, fieldName) {
        var locators = kendo.ui.validator.messageLocators,
            $containers = $(),
            $context = $(context);
        if (!$context.is(FORM)) {
            var $found = $context.parents(FORM);
            if (!$found.length) {
                $found = $context.parents(CONTROL_WRAPPER);
            }
            if ($found.length) {
                $context = $found;
            }
        }
        for (var i = 0, length = $context.length; i < length; i++) {
            $containers = $containers.add(searchForMessageContainer($context[i].getElementsByTagName("*"), fieldName));
        }
        for (var name in locators) {
            if (!locators.hasOwnProperty(name)) {
                continue;
            }
            $containers = $containers.add(locators[name].locate($context, fieldName));
        }
        return $containers;
    }

    function decorateMessageContainer($container, fieldName) {
        var locators = kendo.ui.validator.messageLocators;
        $container
            .addClass(CLASS_INVALID_MSG)
            .attr(kendo.attr(ATTR_FOR), fieldName || "");
        for (var name in locators) {
            if (!locators.hasOwnProperty(name)) {
                continue;
            }
            locators[name].decorate($container, fieldName);
            $container.attr(ATTR_ROLE, ALERT);
        }
    }

    /**
     * Replaces remaining validation message placeholders after validating
     * widget value. There is following list of placeholders to be replaced
     * as of now:
     *
     * {Value} - Current input value.
     * {TotalLength} - The length of string input value.
     */
    function prepareErrorMessageText(input, message) {
        var value = kendo.getInputValue(input),
            data = {
                "Value": value,
                "TotalLength": (typeof value == "string" ? value.length : 0)
            };
        return message ? message.formatWith(data) : "";
    }

    function addAriaErrorMessage($input, message) {
        var id = $input.attr(ATTR_ID) + "-" + ARIA_DESCRIBED_BY;
        // First check if the aria-describedby span with error message is not added to page.
        // If yes, then just replace the message.
        // If not, then add a new span with the message.
        var $ariaWrapper = $input.siblings("#" + id);
        if (!$ariaWrapper.length) {
            $ariaWrapper = $(SPAN)
                .attr({ ATTR_ID: id, ATTR_ROLE: ALERT })
                .addClass(HIDDEN_VISUALLY);
            $ariaWrapper.appendTo($input.parent());
        }
        $ariaWrapper.html(message);
        // TODO: what is the meaning of following comment?
        // The attr-s below can not be combined under single object because when combined,
        // the key of the object appears with underscore and not with dash, like: 
        // aria_invalid = true when it should be aria-invalid = true
        $input
            .attr(ARIA_INVALID, true)
            .attr(ARIA_DESCRIBED_BY, id);
    }

    function removeAriaErrorMessage($input) {
        var id = "#" + $input.attr(ATTR_ID) + "-" + ARIA_DESCRIBED_BY,
            $ariaWrapper = $(id);
        $input.removeAttr(ARIA_INVALID + " " + ARIA_DESCRIBED_BY);
        $ariaWrapper.remove();
    }

    /**
     * Appends or replaces an input validation message at a widget.
     * @param input Input on which to create / show the error message
     * @param message Error message text
     * @param options Optional override of options for rendering the error message UI.
     */
    function errorMessage(input, message, options) {
        var // validated input element
            $input = $(input),
            // component instance
            instance = kendo.findWidgetInstance($input),
            fieldName = $input.attr(ATTR_NAME) || "",
            fieldId = $input.attr(ATTR_ID) || fieldName,
            // old validation label / icon if any
            $lbl = findMessageContainer($input, fieldName).add($input.next("." + CLASS_INVALID_MSG)),
            // resolve current options; options in input have precedence
            currentOptions = $.extend(true, {}, DEFAULT_OPTIONS, options, instance ? instance.options : {}),
            descriptionUiType = $input.data(ATTR_DESCR_UI_TYPE) || currentOptions.descriptionUi,
            validationUiType = $input.data(ATTR_VAL_UI_TYPE) || currentOptions.validationUi,
            duration = currentOptions.duration,
            template = kendo.template(currentOptions.templates[WIDGET_ERROR_TEMPLATE_PREFIX + validationUiType]),
            data = {
                message: prepareErrorMessageText($input, kendo.decode(message)),
                control: fieldId ? " " + ATTR_FOR + '="' + fieldId + '"' : "",
                successIconClass: currentOptions.successIconCssClass,
                errorIconClass: currentOptions.errorIconCssClass,
                successSummaryClass: currentOptions.successSummaryCssClass,
                errorSummaryClass: currentOptions.errorSummaryCssClass
            },
            markup = template(data),
            $wrapper = kendo.findWrapper($input),
            hasWrapper = Boolean($wrapper && $wrapper.length),
            $outer = hasWrapper ? $wrapper : $input,
            errorIcon = "." + currentOptions.errorIconCssClass,
            successIcon = "." + currentOptions.successIconCssClass,
            applyErrorClass = true;

        if (validationUiType !== VAL_UI_ICON) {
            $outer.removeClass(WITH_VAL_ICON);
        }
        if ($lbl.length) {
            kendo.removeElementTooltips($lbl);
            if (validationUiType !== VAL_UI_ICON || !$lbl.is(errorIcon)) {
                $lbl.remove();
            }
        }
        if ($outer.length && (validationUiType === VAL_UI_TOOLTIP || descriptionUiType !== DESCR_UI_TOOLTIP)) {
            kendo.removeElementTooltips($outer);
        }
        if ($outer.length && (validationUiType === VAL_UI_TITLE || descriptionUiType !== DESCR_UI_TITLE)) {
            $input.removeAttr(ATTR_TITLE);
            if (hasWrapper) {
                $wrapper.removeAttr(ATTR_TITLE);
            }
        }
        switch (validationUiType) {
            case VAL_UI_NONE:
                // just keeps hidden validation messages for a particular widget;
                // could be useful for displaying messages only in a summary
                // without any change on widgets
                applyErrorClass = false;
                break;
            case VAL_UI_HIGHLIGHT:
                // highlights border and / or label in case of checkboxes etc.
                break;
            case VAL_UI_TITLE:
                // as previous + title attribute with error message on widget
                if (hasWrapper) {
                    $wrapper.attr(ATTR_TITLE, markup);
                }
                $input.attr(ATTR_TITLE, markup);
                break;
            case VAL_UI_TOOLTIP:
                // as previous, instead of title uses Kendo tooltip for error
                // messages on whole widget
                // TODO : after applying the tooltip directly on $input the ID
                // was removed from it in some strange way. Moving the tooltip
                // to $wrapper solved the issue. For widgets without a wrapper
                // this should still be investigated.
                kendo.applyElementTooltips($outer, { content: markup, duration: duration });
                break;
            case VAL_UI_ICON:
                // as previous, tooltip validation icon is shown with error
                // tooltip applied
                // remove title / tooltip icon when present
                var descrIcon = "." + ((instance ? instance.options.descriptionIconCssClass : null) || DESCR_ICON),
                    $descrIcon = (hasWrapper ? $wrapper : $input.parent()).find(descrIcon),
                    hadLabel = $lbl.length > 0;
                if ($descrIcon.length) {
                    kendo.removeElementTooltips($descrIcon);
                    $descrIcon.remove();
                }
                // create / replace new validation icon
                if (!hadLabel) {
                    $lbl = $(markup);
                }
                $lbl.hide();
                var $validationIcon = $lbl.is(errorIcon) ? $lbl : $lbl.find(errorIcon);
                // search also for success / valid icon, so that we have both cases
                // solved when the icon class changes after validation
                if (!$validationIcon.length) {
                    $validationIcon = $lbl.is(successIcon) ? $lbl : $lbl.find(successIcon);
                }
                // _decorateMessageContainer() in kendo.validator.js uses currently
                // set message label locators to find and replace the error content;
                // MVC locators for message labels are implemented in kendo.aspnetmvc.js
                decorateMessageContainer($lbl, fieldName);
                if (hasWrapper) {
                    $lbl.appendTo($wrapper);
                }
                // show the icon at start
                $validationIcon
                    .stop(true, true)
                    .css({ "opacity": "0", "display": "block" })
                    .removeClass(HIDDEN)
                    .fadeIn({
                        duration: duration,
                        complete: function () { $lbl.attr("style", ""); }
                    });
                $outer.addClass(WITH_VAL_ICON);
                // apply Kendo tooltip, message is taken from title here
                kendo.applyElementTooltips(
                    $validationIcon,
                    { content: data.message, duration: duration }
                );
                break;
            case VAL_UI_BEFORE:
            case VAL_UI_AFTER:
                // places the error message before or after the widget
                $lbl = $(markup);
                decorateMessageContainer($lbl, fieldName);
                $lbl[validationUiType === VAL_UI_BEFORE ? "insertBefore" : "insertAfter"]($outer);
                break;
            case VAL_UI_ELEMENT:
                // custom message placement, finds closest element according
                // to selector in data-val-place-into attribute
                // TODO: backend wrapper for this
                break;
        }

        $input.toggleClass(ERROR, applyErrorClass);
        if (hasWrapper) {
            $wrapper.toggleClass(ERROR, applyErrorClass);
        }

        addAriaErrorMessage($input, data.message);
    }

    /**
     * Hides widget validation message.
     * @param input Input on which to hide the error message.
     * @param options Error UI rendering options override.
     * Here only the validationUi option is of a particular importance.
     */
    function hideErrorMessage(input, options) {
        var // validated input element
            $input = $(input),
            // component instance
            instance = kendo.findWidgetInstance($input),
            fieldName = $input.attr(ATTR_NAME) || "",
            // old validation label / icon if any
            $lbl = findMessageContainer($input, fieldName).add($input.next("." + CLASS_INVALID_MSG)),
            // resolve current options; options in input have precedence
            currentOptions = $.extend(true, {}, DEFAULT_OPTIONS, options, instance ? instance.options : {}),
            validationUiType = $input.data(ATTR_VAL_UI_TYPE) || currentOptions.validationUi,
            $wrapper = kendo.findWrapper($input),
            hasWrapper = Boolean($wrapper && $wrapper.length);

        removeAriaErrorMessage($input);

        $input.toggleClass(ERROR, false);
        if (hasWrapper) {
            $wrapper.toggleClass(ERROR, false);
        }

        (hasWrapper ? $wrapper : $input).removeClass(WITH_VAL_ICON);
        switch (validationUiType) {
            case VAL_UI_TITLE:
                if (hasWrapper) {
                    $wrapper.removeAttr(ATTR_TITLE);
                }
                $input.removeAttr(ATTR_TITLE);
                break;
            case VAL_UI_TOOLTIP:
                kendo.removeElementTooltips(hasWrapper ? $wrapper : $input);
                break;
            case VAL_UI_ICON:
            case VAL_UI_BEFORE:
            case VAL_UI_AFTER:
            case VAL_UI_ELEMENT: // TODO : this one is not tested yet
                hideElement($lbl);
                break;
        }
        // reapply description when set
        if (instance && typeof instance.descriptionUi == "function") {
            instance.descriptionUi();
        }
    }

    /**
     * Appends or replaces a validation message in given summary for specified input.
     * @param summaryErrorsSection Errors list wrapper section found in a validation summary markup.
     * @param input Input for which to hide error message in summary. If not specified, creates
     * a generic error message in validation summary not bound to any particular form field.
     * @param message Error message text to be displayed.
     * @param options Override which might involve the generation / UI of the displayed message.
     */
    function summaryMessage(summaryErrorsSection, input, message, options) {
        var $errors = $(summaryErrorsSection);
        if (!$errors.length) {
            return;
        }
        var // validated input element
            $input = $(input),
            // component instance
            instance = kendo.findWidgetInstance($input),
            fieldName = $input.attr(ATTR_NAME) || "",
            fieldId = $input.attr(ATTR_ID) || fieldName,
            // resolve current options; options in input have precedence
            currentOptions = $.extend(true, {}, DEFAULT_OPTIONS, options, instance ? instance.options : {}),
            validationUiType = $input.data(ATTR_VAL_UI_TYPE) || currentOptions.validationUi,
            duration = currentOptions.duration,
            template = kendo.template(currentOptions.templates[SUMMARY_ERROR_TEMPLATE_PREFIX + validationUiType]),
            data = {
                message: prepareErrorMessageText($input, kendo.decode(message)),
                control: fieldId ? " " + ATTR_FOR + '="' + fieldId + '"' : "",
                successIconClass: currentOptions.successIconCssClass,
                errorIconClass: currentOptions.errorIconCssClass,
                successSummaryClass: currentOptions.successSummaryCssClass,
                errorSummaryClass: currentOptions.errorSummaryCssClass
            },
            markup = template(data),
            $ul = $errors.find(UL),
            $lbl = $ul.find(LABEL + "[" + ATTR_FOR + '="' + fieldId + '"]').parent(),
            replaceLabel = function () {
                var $content = $(markup);
                if ($lbl.length) {
                    $lbl.replaceWith($content);
                } else {
                    $lbl = $content;
                    $lbl.appendTo($ul);
                }
            };

        replaceLabel();
        // show both the whole summary & errors wrapper inside it when hidden
        $errors.removeClass(HIDDEN)
            .parent().removeClass(HIDDEN);
        $lbl.fadeIn({ duration: duration });
    }

    /**
     * Hides validation message in given summary for specified input.
     * @param summaryErrorsSection Errors list wrapper section found in a validation summary markup.
     * @param input Input for which to hide error message in summary. If not specified, hides
     * all generic errors in validation summary.
     */
    function hideSummaryMessage(summaryErrorsSection, input) {
        var $errors = $(summaryErrorsSection);
        if (!$errors.length) {
            return;
        }
        var // validated input element
            $input = $(input),
            // component instance
            fieldName = $input.attr(ATTR_NAME) || "",
            fieldId = $input.attr(ATTR_ID) || fieldName,
            $ul = $errors.find(UL),
            selector = LABEL + (fieldId ? "[" + ATTR_FOR + '="' + fieldId + '"]' : ":not([" + ATTR_FOR + "])"),
            $lbl = $errors.find(selector).parent();
        hideElement($lbl, function () {
            if (!$ul.find(VISIBLE_LIST_ITEM).length) {
                // don't hide the whole summary here, just the errors list wrapper in it
                $errors.addClass(HIDDEN);
            }
        });
    }

    // publish needed methods into global kendo namespace
    $.extend(true, kendo.ui, {
        defaultValidatorHighlighterOptions: DEFAULT_OPTIONS,
        errorMessage: errorMessage,
        hideErrorMessage: hideErrorMessage,
        summaryMessage: summaryMessage,
        hideSummaryMessage: hideSummaryMessage
    });

    kendo.ui.errorHighlightingUpdated = true;

})(window.kendo.jQuery);
